import { useAuth } from '@/features/auth'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useRedirectLoggedInUsers = () => {
  const navigate = useNavigate()
  const auth = useAuth()

  useEffect(() => {
    if (!auth.isLoggedIn()) return
    navigate('/dashboard')
  }, [auth, navigate])
}
